export const mockupsCustomers = ({dispatch}) => next => (action) => {
    next(action);
}
